namespace app.services.authentication {
  export class PermissionService implements IService {
    private ItemResource: any;

    constructor($resource: angular.resource.IResourceService, configService: app.services.IConfigService, resourceWrapperService: app.services.utilities.ResourceWrapperService) {
      let roleResource = $resource(`${configService.getServerBaseUrlForResource()}/project/:projectId/permissions/:id`,
        {id: "@id", projectId: "@projectId"},
        {update: {method: "PUT"}});

      this.ItemResource = resourceWrapperService.WrapActions(roleResource);
    }

    public findByProjectId(projectId: string, callBack: Function) {
      return this.ItemResource.query({projectId: projectId}, (roles: any) => callBack && callBack(roles));
    }
  }

  frontendApp.factory("PermissionService", ["$resource", "ConfigService", "ResourceWrapperService", function($resource, configService, resourceWrapperService) {
    return new PermissionService($resource, configService, resourceWrapperService);
  }]);
}
